import React, { useState, useEffect } from 'react';

// Components
import { WpTabs, WpTab } from 'Wpds/components/tabs';
import WorkspaceSideRailTeam from './WorkspaceSideRailTeam';
import WorkspaceTeamSnapshot from '../WorkspaceTeamSnapshot/WorkspaceTeamSnapshot';
import NoDesignAccessTipsComponent from '../WorkspaceTeamSnapshot/NoDesignAccessTipsComponent';

// Hooks
import { useSmac } from 'Shared/utils/hooks/use-smac';

// Styles
import './WorkspaceSideRail.scss';

enum TabId {
  tips = 'tips',
  teamMembers = 'teamMembers',
}

const WorkspaceSideRail: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>(TabId.tips);
  const { hasDesign2Access } = useSmac();

  const baseClassName = 'WorkspaceSideRail';

  useEffect(() => {
    // If no design access, set the active tab to team members
    if (!hasDesign2Access) {
      setActiveTab(TabId.teamMembers);
    }
  }, [hasDesign2Access]);

  return (
    <div className={baseClassName}>
      <WpTabs activeTab={activeTab} onTabClick={setActiveTab}>
        <WpTab qaTest="tips" tabId={TabId.tips}>
          Tips
        </WpTab>
        <WpTab qaTest="teamMembers" tabId={TabId.teamMembers}>
          Team Members
        </WpTab>
      </WpTabs>
      <div className={`${baseClassName}__content`}>
        {activeTab === TabId.tips && (
          <div className={`${baseClassName}__content__tips`}>
            {hasDesign2Access ? <WorkspaceTeamSnapshot /> : <NoDesignAccessTipsComponent />}
          </div>
        )}
        {activeTab === TabId.teamMembers && (
          <div className={`${baseClassName}__content__teams`}>
            <WorkspaceSideRailTeam />
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkspaceSideRail;
